export const getURLParam = (url: string, param: string) => {
  const searchParams = new URLSearchParams(url);

  return searchParams.has(param) ? searchParams.get(param) : null;
};

export const parseLink = (text: string): { start: string; link: string; end: string } => {
  const splitText = text.split("[#link_start#]");
  const start = splitText.length > 0 ? splitText[0]! : "";
  const linkEnd = splitText.length > 1 ? splitText[1]!.split("[#link_end#]") : [];
  const link = linkEnd.length > 0 ? linkEnd[0]! : "";
  const end = linkEnd.length > 1 ? linkEnd[1]! : "";

  return {
    start,
    link,
    end,
  };
};
